import type { GetAutoApplyDraftListQuery } from './__generated__/AutoApplyIndexPage.generated';

/**
 * Draft IDs that still have screener questions to answer, from `GetAutoApplyDraftList`.
 *
 * A `null` count means the server doesn't know, which is distinct from `0` — neither routes the
 * seeker to the questions step. Shared by `useAutoApplyFlow` (which inserts the step) and
 * `AutoApplyIndexPage` (which picks the entry step) so that rule lives in one place.
 */
export const getDraftIdsNeedingQuestions = (
    data: GetAutoApplyDraftListQuery | undefined,
): Set<string> =>
    new Set(
        (data?.findReviewBeforeSubmitDrafts?.drafts ?? [])
            .filter((draft) => (draft.unfilledScreenerQuestionCount ?? 0) > 0)
            .map((draft) => draft.applicationDraftId),
    );
